var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarning = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 51,
    viewBox: "0 0 56 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7388 9.68283C28.969 8.34974 27.0448 8.34974 26.2749 9.68283L7.51237 42.1725C6.74238 43.5058 7.70462 45.1727 9.24432 45.1727H46.7695C48.3092 45.1727 49.2715 43.5058 48.5015 42.1725L29.7388 9.68283Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7388 9.68283C28.969 8.34974 27.0448 8.34974 26.2749 9.68283L7.51237 42.1725C6.74238 43.5058 7.70462 45.1727 9.24432 45.1727H46.7695C48.3092 45.1727 49.2715 43.5058 48.5015 42.1725L29.7388 9.68283Z",
    fill: "#FF9800",
    fillOpacity: 0.18
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3211 43.0466L32.4117 3.37647C31.9703 2.59084 31.3234 1.93609 30.5402 1.48254C29.372 0.806035 28.0105 0.625073 26.7058 0.972564C25.4012 1.32017 24.3104 2.15467 23.633 3.32376L0.847945 42.7788C-1.39042 46.0805 1.07434 50.6746 5.06734 50.6398H50.9509C51.826 50.6398 52.7006 50.4012 53.4798 49.95C55.8912 48.5538 56.7169 45.4563 55.3211 43.0466ZM52.3835 48.0576C51.9369 48.3162 51.4417 48.4528 50.9498 48.4528H5.06734C2.78883 48.4726 1.39195 45.8425 2.68274 43.9698C2.69728 43.9484 2.71107 43.9264 2.72397 43.9037L25.5266 4.4184C25.9103 3.756 26.529 3.28265 27.269 3.08572C28.0037 2.88924 28.78 2.98994 29.4438 3.37494C29.8893 3.63299 30.2569 4.00519 30.5067 4.45131C30.509 4.45546 30.5114 4.45973 30.5138 4.46388L53.4274 44.1413C54.2195 45.5088 53.7513 47.2656 52.3835 48.0576Z",
    fill: "#FF9800"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3211 43.0466L32.4117 3.37647C31.9703 2.59084 31.3234 1.93609 30.5402 1.48254C29.372 0.806035 28.0105 0.625073 26.7058 0.972564C25.4012 1.32017 24.3104 2.15467 23.633 3.32376L0.847945 42.7788C-1.39042 46.0805 1.07434 50.6746 5.06734 50.6398H50.9509C51.826 50.6398 52.7006 50.4012 53.4798 49.95C55.8912 48.5538 56.7169 45.4563 55.3211 43.0466ZM52.3835 48.0576C51.9369 48.3162 51.4417 48.4528 50.9498 48.4528H5.06734C2.78883 48.4726 1.39195 45.8425 2.68274 43.9698C2.69728 43.9484 2.71107 43.9264 2.72397 43.9037L25.5266 4.4184C25.9103 3.756 26.529 3.28265 27.269 3.08572C28.0037 2.88924 28.78 2.98994 29.4438 3.37494C29.8893 3.63299 30.2569 4.00519 30.5067 4.45131C30.509 4.45546 30.5114 4.45973 30.5138 4.46388L53.4274 44.1413C54.2195 45.5088 53.7513 47.2656 52.3835 48.0576Z",
    fill: "black",
    fillOpacity: 0.6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25.1562,
    y: 15.988,
    width: 5.60001,
    height: 16.7958,
    fill: "#FF9800"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.1562,
    y: 15.988,
    width: 5.60001,
    height: 16.7958,
    fill: "black",
    fillOpacity: 0.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25.1562,
    y: 36.0994,
    width: 5.60001,
    height: 5.59861,
    fill: "#FF9800"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 25.1562,
    y: 36.0994,
    width: 5.60001,
    height: 5.59861,
    fill: "black",
    fillOpacity: 0.6
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/warning.6f5903523113a591a5f4ae2e89facad9.svg";